import type { ObservationCommentsListProps } from "./observation-comments-list.type";

import { useTranslation } from "react-i18next";

import ListLoadMoreButton from "@/components/Elements/ListLoadMoreButton";
import { ObservationItem } from "@/components/Observation";
import { useGetObservationComments } from "@/entities/observation";
import CommentCard from "@/modules/comment/comment-card";
import { FetchDataWrapper } from "@/modules/fetch-data-wrapper";
import { CommentCardSkeleton } from "@/ui/comment-card-skeleton";

import "./observation-comments-list.style.less";

const ObservationCommentsList = ({
  observation,
  loading,
}: ObservationCommentsListProps) => {
  const { t } = useTranslation();
  const {
    comments,
    pagination,
    hasNextPage,
    onLoadMore,
    isFetching,
    isFetchingNextPage,
    isLoading,
    error,
  } = useGetObservationComments(observation);

  return (
    <div className="observation-comments-list">
      <FetchDataWrapper
        data={comments}
        error={error}
        loading={loading || isLoading}
        emptyDescription={t("comment:noComment")}
        loader={<CommentCardSkeleton />}
      >
        {isFetching && !isFetchingNextPage && <CommentCardSkeleton />}
        {comments.map((comment) => (
          <CommentCard
            comment={comment}
            key={`observation-comment-${comment.id}`}
          />
        ))}
        {hasNextPage && (
          <ListLoadMoreButton
            pagination={pagination}
            itemName={t("comment:singular")}
            loading={isFetchingNextPage}
            onClick={onLoadMore}
          />
        )}
      </FetchDataWrapper>
    </div>
  );
};

ObservationCommentsList.propTypes = {
  observation: ObservationItem,
};

export default ObservationCommentsList;
